import { faLock } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { tv } from "tailwind-variants";

const styles = tv({
  slots: {
    parent: "group flex min-w-[100px] flex-col",
    child: "transition-all px-20 pb-[16px] text-center duration-500",
    border:
      "transition-colors h-[4px] w-full rounded-t-lg bg-transparent group-hover:bg-gray",
  },
  variants: {
    isActive: {
      true: {
        child: "font-semibold",
        border: "bg-primary group-hover:bg-primary",
      },
    },
    isLocked: {
      true: {
        parent: "pointer-events-none cursor-not-allowed",
        child: "text-gray-dark",
      },
    },
    minimize: {
      true: {
        child: "pb-[6px]",
      },
    },
  },
});

interface IProps {
  to: string;
  isActive: boolean;
  isLocked: boolean;
  external: boolean;
  newTab: boolean;
  minimize: boolean;
  children: ReactNode;
}

const NavLink = ({
  to,
  isActive,
  isLocked,
  external,
  newTab,
  minimize,
  children,
}: IProps) => {
  const { parent, child, border } = styles({ isActive, isLocked, minimize });

  const renderLockedIcon = () =>
    isLocked && <FontAwesomeIcon fixedWidth icon={faLock} className="ml-10" />;

  if (external) {
    return (
      <a
        href={to}
        className={parent()}
        target={newTab ? "_blank" : "_self"}
        data-testid="header-nav-link">
        <div className={child()}>
          {children}
          {renderLockedIcon()}
        </div>
        <div className={border()} data-testid="header-nav-link-border" />
      </a>
    );
  }

  return (
    <Link to={to} className={parent()} data-testid="header-nav-link">
      <div className={child()}>
        {children}
        {renderLockedIcon()}
      </div>
      <div data-testid="header-nav-link-border" className={border()} />
    </Link>
  );
};

export default NavLink;
